export const PRISMIC_API_ENDPOINT = 'https://boekelseverleiding.cdn.prismic.io/api/v2';
export const PRISMIC_API_TOKEN = 'MC5YRngxOVJBQUFDRUFJWjND.77-9Ze-_vSjvv73vv71P77-9O--_ve-_vXRiRS_vv73vv73vv73vv70gJRTvv706W3zvv73vv73vv70FdxI';
